import { SVGProps } from 'react'

export const Users = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="23"
    height="20"
    viewBox="0 0 23 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.4998 13.8369C18.9557 14.5683 20.204 15.742 21.1151 17.2096C21.2955 17.5003 21.3857 17.6456 21.4169 17.8468C21.4803 18.2558 21.2006 18.7585 20.8198 18.9204C20.6323 19 20.4215 19 19.9998 19M15.4998 9.53224C16.9816 8.79589 17.9998 7.26686 17.9998 5.5C17.9998 3.73314 16.9816 2.20411 15.4998 1.46776M13.4998 5.5C13.4998 7.98528 11.4851 10 8.99984 10C6.51455 10 4.49984 7.98528 4.49984 5.5C4.49984 3.01472 6.51455 1 8.99984 1C11.4851 1 13.4998 3.01472 13.4998 5.5ZM2.05907 16.9383C3.65337 14.5446 6.16921 13 8.99984 13C11.8305 13 14.3463 14.5446 15.9406 16.9383C16.2899 17.4628 16.4645 17.725 16.4444 18.0599C16.4287 18.3207 16.2578 18.64 16.0494 18.7976C15.7818 19 15.4137 19 14.6775 19H3.32219C2.58601 19 2.21791 19 1.95028 18.7976C1.74189 18.64 1.57092 18.3207 1.55527 18.0599C1.53517 17.725 1.7098 17.4628 2.05907 16.9383Z"
      stroke="#475467"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
